export const IocKey = {
  factory: Symbol.for('instance.factory'),
  isBound: Symbol.for('instance.isBound'),

  adjustment: {
    repository: {
      adjustment: Symbol.for('adjustment.repository.adjustment'),
      adjustmentRemarksActivity: Symbol.for('adjustment.repository.adjustmentRemarksActivity'),
    },
    service: {
      createAndAdjust: Symbol.for('adjustment.service.createAndAdjust'),
      stateTransition: Symbol.for('adjustment.service.stateTransition'),
    },
    action: {
      fulfillAdjustment: Symbol.for('adjustment.action.fulfillAdjustment'),
    },
  },

  autonumber: {
    service: {
      autonumber: Symbol.for('autonumber.service.autonumber'),
    },
  },

  auth: {
    service: {
      passwordlessDeliveryFactory: Symbol.for('auth.service.passwordlessDeliveryFactory'),
      passwordlessSmsDelivery: Symbol.for('auth.service.passwordlessSmsDelivery'),
      passwordlessEmailDelivery: Symbol.for('auth.service.passwordlessEmailDelivery'),
      jwtVerifier: Symbol.for('auth.service.jwtVerifier'),
    },
  },

  appSetting: {
    repository: {
      appSetting: Symbol.for('appSetting.repository.appSetting'),
    },
    service: {
      appSetting: Symbol.for('appSetting.service.appSetting'),
    },
  },

  board: {
    repository: {
      board: Symbol.for('board.repository.board'),
    },
  },
  blog: {
    repository: {
      blog: Symbol.for('blog.repository.blog'),
    },
    service: {
      blog: Symbol.for('blog.service.blog'),
    },
    queue: {
      transcription: Symbol.for('blog.queue.transcription'),
    },
    action: {
      transcribeBlogVideos: Symbol.for('blog.action.transcribeBlogVideos'),
      processBlogTranscription: Symbol.for('blog.action.processBlogTranscription'),
      cancelBlogTranscriptionJob: Symbol.for('blog.action.cancelBlogTranscriptionJob'),
    },
  },
  cache: {
    service: {
      cache: Symbol.for('cache.service.cache'),
    },
  },
  company: {
    repository: {
      company: Symbol.for('company.repository.company'),
      companyAddresses: Symbol.for('company.repository.companyAddresses'),
    },
    service: {
      updateRelatedToCompany: Symbol.for('company.service.updateRelatedToCompany'),
      createCompanyIfNotExists: Symbol.for('company.service.createCompanyIfNotExists'),
    },
  },
  customer: {
    repository: {
      customer: Symbol.for('customer.repository.customer'),
      customerAddresses: Symbol.for('customer.repository.customerAddresses'),
    },
    service: {
      manageCustomerOrCompanyAddress: Symbol.for('customer.service.manageCustomerOrCompanyAddress'),
      additionalCustomerFiltersAndInputs: Symbol.for('customer.service.additionalCustomerFiltersAndInputs'),
      getBasicCustomerInfo: Symbol.for('customer.service.getBasicCustomerInfo'),
      updateRelatedToCustomer: Symbol.for('customer.service.updateRelatedToCustomer'),
      createCustomerFromEmail: Symbol.for('customer.service.createCustomerFromEmail'),
    },
  },
  chat: {
    gateway: {
      chat: Symbol.for('chat.gateway.chat'),
    },
    queue: {
      autoClose: Symbol.for('chat.queue.autoClose'),
    },
    repository: {
      chat: Symbol.for('chat.repository.chat'),
      message: Symbol.for('chat.repository.message'),
    },
    service: {
      refreshChatMessages: Symbol.for('chat.service.refreshChatMessages'),
      userCache: Symbol.for('chat.service.userCache'),
      addCollaborators: Symbol.for('chat.service.addCollaborators'),
      addChatMessage: Symbol.for('chat.service.addChatMessage'),
      startStorefrontConversation: Symbol.for('chat.service.startStorefrontConversation'),
      conversationChannel: Symbol.for('chat.service.communicationChannel'),
      formalizeCommunication: Symbol.for('chat.service.formalizeCommunication'),
      addChatInternalNote: Symbol.for('chat.service.addChatInternalNote'),
      requesterResolver: Symbol.for('chat.service.requesterResolver'),
      addCustomerChatReply: Symbol.for('chat.service.addCustomerChatReply'),
    },
  },
  cron: {
    service: {
      cron: Symbol.for('cron.service.cron'),
    },
  },
  dbBackup: {
    service: {
      dbBackup: Symbol.for('dbBackup.service.dbBackup'),
    },
  },
  documentAsset: {
    service: {
      lookup: Symbol.for('documentAsset.service.lookup'),
      attachAssets: Symbol.for('documentAsset.service.attachAssets'),
    },
  },
  documentLock: {
    repository: {
      documentLock: Symbol.for('documentLock.repository.documentLock'),
    },
    service: {
      documentLock: Symbol.for('documentLock.service.documentLock'),
    },
  },
  history: {
    repository: {
      history: Symbol.for('history.repository.history'),
    },
    service: {
      history: Symbol.for('history.service.history'),
    },
  },
  inventoryTimeSeries: {
    repository: {
      inventoryTimeSeries: Symbol.for('inventoryTimeSeries.repository.inventoryTimeSeries'),
    },
    service: {
      inventoryTimeSeries: Symbol.for('inventoryTimeSeries.service.inventoryTimeSeries'),
    },
  },
  inventoryBySerialNumber: {
    repository: {
      inventoryBySerialNumber: Symbol.for('inventoryBySerialNumber.repository.inventoryBySerialNumber'),
    },
    service: {
      generateSerialNumber: Symbol.for('inventoryBySerialNumber.service.generateSerialNumber'),
      addMultipleSerialNumbers: Symbol.for('inventoryBySerialNumber.service.addMultipleSerialNumbers'),
      updateProductInventoryWithSerialNumbers: Symbol.for(
        'inventoryBySerialNumber.service.updateProductInventoryWithSerialNumbers'
      ),
      validateSerialNumber: Symbol.for('inventoryBySerialNumber.validator.validateSerialNumber'),
    },
  },
  telemetry: {
    service: {
      tracer: Symbol.for('telemetry.service.tracer'),
      log: Symbol.for('telemetry.service.log'),
    },
    mongodbConnection: Symbol.for('telemetry.mongodbConnection'),
  },
  logistic: {
    service: {
      stateTransition: Symbol.for('logistic.service.stateTransition'),
      updateLogisticShippingStatus: Symbol.for('logistic.service.updateLogisticShippingStatus'),
      shipEngineWebhookHandler: Symbol.for('logistic.service.shipEngineWebhookHandler'),
    },
    repository: {
      logistic: Symbol.for('logistic.repository.logistic'),
      logisticItem: Symbol.for('logistic.repository.logisticItem'),
      logisticRelatedLogistic: Symbol.for('logistic.repository.logisticRelatedLogistic'),
      logisticRemarksActivity: Symbol.for('logistic.repository.logisticRemarksActivity'),
      logisticAsset: Symbol.for('logistic.repository.logisticAsset'),
    },
  },
  mail: {
    service: {
      mail: Symbol.for('mail.service.mail'),
    },
  },
  mailgunEvent: {
    repository: {
      mailgunEvent: Symbol.for('mailgunEvent.repository.mailgunEvent'),
    },
  },
  mcp: {
    handler: {
      jsonRpc: Symbol.for('mcp.handler.jsonRpc'),
      mcpInitialize: Symbol.for('mcp.handler.mcpInitialize'),
    },
    service: {
      toolRegistry: Symbol.for('mcp.service.toolRegistry'),
      graphQLClient: Symbol.for('mcp.service.graphQLClient'),
    },
  },
  notification: {
    repository: {
      notification: Symbol.for('notification.repository.notification'),
    },
  },
  order: {
    repository: {
      order: Symbol.for('order.repository.order'),
      orderItem: Symbol.for('order.repository.orderItem'),
      orderAsset: Symbol.for('order.repository.orderAsset'),
      orderRemarksActivity: Symbol.for('order.repository.orderRemarksActivity'),
      orderPayments: Symbol.for('order.repository.orderPayments'),
    },
    service: {
      stateTransition: Symbol.for('order.service.stateTransition'),
      order: Symbol.for('order.service.order'),
      getOrderedProducts: Symbol.for('order.service.getOrderedProducts'),
      fulfillOrder: Symbol.for('order.service.fulfillOrder'),
      capturePayment: Symbol.for('order.service.capturePayment'),
      notifyOrder: Symbol.for('order.service.notifyOrder'),
      setShippingRate: Symbol.for('order.service.setShippingRate'),
      setCustomShippingCarrier: Symbol.for('order.service.setCustomShippingCarrier'),
      updateInventoryBySerialNumberStatus: Symbol.for('order.service.updateInventoryBySerialNumberStatus'),
      extractOrderAddresses: Symbol.for('order.service.extractOrderAddresses'),
      markOrderNotReceivable: Symbol.for('order.service.markOrderNotReceivable'),
      createOrderPaymentLink: Symbol.for('order.service.createOrderPaymentLink'),
      createOrderCheckoutSession: Symbol.for('order.service.createOrderCheckoutSession'),
      createOrderBankTransfer: Symbol.for('order.service.createOrderBankTransfer'),
      shipEngineWebhookHandler: Symbol.for('order.service.shipEngineWebhookHandler'),
    },
  },

  product: {
    repository: {
      product: Symbol.for('product.repository.product'),
      productVendors: Symbol.for('product.repository.productVendors'),
      productBillOfMaterials: Symbol.for('product.repository.productBillOfMaterials'),
      productOperations: Symbol.for('product.repository.productOperations'),
      relatedProducts: Symbol.for('product.repository.relatedProducts'),
      productRemarksActivity: Symbol.for('product.repository.productRemarksActivity'),
      lowProductInventory: Symbol.for('product.repository.lowProductInventory'),
      productAsset: Symbol.for('product.repository.productAsset'),
    },
    service: {
      hasReferenceToOtherEntity: Symbol.for('product.service.hasReferenceToOtherEntity'),
      adjustMultipleProductInventory: Symbol.for('product.service.adjustMultipleProductInventory'),
      getProductComputedQuantityOnHand: Symbol.for('product.service.getProductComputedQuantityOnHand'),
      adjustProductQty: Symbol.for('product.service.adjustProductQty'),
      productBuild: Symbol.for('product.service.productBuild'),
      productDestruct: Symbol.for('product.service.productDestruct'),
      getProductsWithBillingMaterials: Symbol.for('product.service.getProductsWithBillingMaterials'),
      hasSubComponents: Symbol.for('product.service.hasSubComponents'),
      getProductUsedIn: Symbol.for('product.service.getProductUsedIn'),
      buildProductFromDraft: Symbol.for('product.service.buildProductFromDraft'),
    },
    queue: {
      lowInventoryRefresh: Symbol.for('product.queue.lowInventoryRefresh'),
      recomputeProductQuantity: Symbol.for('product.queue.recomputeProductQuantity'),
      recomputeProductQuantityScheduler: Symbol.for('product.queue.recomputeProductQuantityScheduler'),
    },
  },
  project: {
    repository: {
      project: Symbol.for('project.repository.project'),
      projectRemarksActivity: Symbol.for('project.repository.projectRemarksActivity'),
      projectRelatedWorkOrders: Symbol.for('project.repository.projectRelatedWorkOrders'),
      projectAsset: Symbol.for('project.repository.projectAsset'),
    },
    service: {
      addProjectTasks: Symbol.for('project.service.addProjectTasks'),
      createProjectAndTasks: Symbol.for('project.service.createProjectAndTasks'),
      computeTotalTimeSpent: Symbol.for('project.service.computeTotalTimeSpent'),
      computeProjectTaskProgress: Symbol.for('project.service.computeProjectTaskProgress'),
      updateStatusByTasks: Symbol.for('project.service.updateStatusByTasks'),
      stateTransition: Symbol.for('project.service.stateTransition'),
      cloneProjectTask: Symbol.for('project.service.cloneProjectTask'),
      cloneProject: Symbol.for('project.service.cloneProject'),
    },
  },
  purchaseOrder: {
    service: {
      stateTransition: Symbol.for('purchaseOrder.service.stateTransition'),
    },
    repository: {
      purchaseOrder: Symbol.for('purchaseOrder.repository.purchaseOrder'),
      purchaseOrderItem: Symbol.for('purchaseOrder.repository.purchaseOrderItem'),
      purchaseOrderRemarksActivity: Symbol.for('purchaseOrder.repository.purchaseOrderRemarksActivity'),
      purchaseOrderAsset: Symbol.for('purchaseOrder.repository.purchaseOrderAsset'),
    },
  },
  returnOrder: {
    repository: {
      returnOrder: Symbol.for('returnOrder.repository.returnOrder'),
    },
  },
  payment: {
    repository: {
      stripe: Symbol.for('payment.repository.stripe'),
      coupon: Symbol.for('payment.repository.coupon'),
      couponRedemption: Symbol.for('payment.repository.couponRedemption'),
    },
    gateway: {
      payment: Symbol.for('payment.gateway.payment'),
    },
    service: {
      refundPayment: Symbol.for('payment.service.refundPayment'),
      createAchPayment: Symbol.for('payment.service.createAchPayment'),
      getPaymentMetadata: Symbol.for('payment.service.getPaymentMetadata'),
      captureCardPayment: Symbol.for('payment.service.captureCardPayment'),
      cancelUncapturedPayment: Symbol.for('payment.service.cancelUncapturedPayment'),
      storePaymentData: Symbol.for('payment.service.storePaymentData'),
      storeStripePaymentQueue: Symbol.for('payment.service.storeStripePaymentQueue'),
      createBankTransfer: Symbol.for('payment.service.createBankTransfer'),
      validateCoupon: Symbol.for('payment.service.validateCoupon'),
      redeemCoupon: Symbol.for('payment.service.redeemCoupon'),
    },
  },
  queue: {
    service: {
      queue: Symbol.for('queue.service.queue'),
    },
  },
  qbo: {
    service: {
      qbo: Symbol.for('qbo.service.qbo'),
      createQuickbooksInvoice: Symbol.for('qbo.service.createQuickbooksInvoice'),
      itemMapping: Symbol.for('qbo.service.itemMapping'),
      customerMapping: Symbol.for('qbo.service.customerMapping'),
      quickbooksInvoice: Symbol.for('qbo.service.quickbooksInvoice'),
    },
  },
  shipping: {
    repository: {
      shipEngine: Symbol.for('shipping.repository.shipEngine'),
    },
    service: {
      cancelShipping: Symbol.for('shipping.service.cancelShipping'),
      createShipping: Symbol.for('shipping.service.createShipping'),
      getShippingRate: Symbol.for('shipping.service.getShippingRate'),
      estimateShippingFee: Symbol.for('shipping.service.estimateShippingFee'),
      shipEngineWebhookHandlerRegistry: Symbol.for('shipping.service.shipEngineWebhookHandlerRegistry'),
    },
    gateway: {
      shipping: Symbol.for('shipping.gateway.shipping'),
    },
    queue: {
      uploadShipEngineLabel: Symbol.for('shipping.queue.uploadShipEngineLabel'),
    },
  },
  sms: {
    service: {
      sms: Symbol.for('sms.sms'),
      simPortManager: Symbol.for('sms.service.simPortManager'),
    },
    gateway: {
      sms: Symbol.for('sms.gateway.sms'),
    },
  },
  task: {
    repository: {
      task: Symbol.for('task.repository.task'),
      taskRemarksActivity: Symbol.for('task.repository.taskRemarksActivity'),
      taskAsset: Symbol.for('task.repository.taskAsset'),
    },
    service: {
      stateTransition: Symbol.for('task.service.stateTransition'),
      getSortedTasks: Symbol.for('task.service.getSortedTasks'),
      addTaskSubTasks: Symbol.for('task.service.addTaskSubTasks'),
      deleteTaskSubTasks: Symbol.for('task.service.deleteTaskSubTasks'),
      sortTaskSubTasks: Symbol.for('task.service.sortTaskSubTasks'),
      actionHookRegistry: Symbol.for('task.service.actionHookRegistry'),
      actionHookExecutor: Symbol.for('task.service.actionHookExecutor'),
    },
    actionHook: {
      updateInventory: Symbol.for('task.actionHook.updateInventory'),
      createLogistic: Symbol.for('task.actionHook.createLogistic'),
    },
  },
  tenant: {
    repository: {
      tenant: Symbol.for('tenant.repository.tenant'),
    },
    service: {
      tenant: Symbol.for('tenant.service.tenant'),
    },
  },
  template: {
    repository: {
      template: Symbol.for('template.repository.template'),
    },
  },
  file: {
    repository: {
      file: Symbol.for('file.repository.file'),
      storage: Symbol.for('file.repository.storage'),
    },
    service: {
      file: Symbol.for('file.service.file'),
    },
  },
  pubsub: {
    service: {
      pubsub: Symbol.for('pubsub.service.pubsub'),
    },
  },

  s3: {
    service: {
      s3: Symbol.for('s3.service.s3'),
    },
  },

  stripe: {
    service: {
      processStripeEvents: Symbol.for('stripe.service.processStripeEvents'),
      stripe: Symbol.for('stripe.service.stripe'),
    },
  },

  user: {
    repository: {
      user: Symbol.for('user.repository.user'),
      userAddresses: Symbol.for('user.repository.userAddresses'),
    },
    service: {
      user: Symbol.for('user.service.user'),
      appUser: Symbol.for('user.service.appUser'),
      manageUserOrCompanyAddress: Symbol.for('user.service.manageUserOrCompanyAddress'),
      getUserAddresses: Symbol.for('user.service.getUserAddresses'),
      cache: Symbol.for('user.service.cache'),
    },
    validator: {
      user: Symbol.for('user.validator.user'),
    },
  },
  unitOfMeasure: {
    repository: {
      unitOfMeasure: Symbol.for('unitOfMeasure.repository.unitOfMeasure'),
    },
  },

  vendor: {
    repository: {
      vendor: Symbol.for('vendor.repository.vendor'),
    },
  },
  viewCount: {
    repository: {
      viewCount: Symbol.for('viewCount.repository.viewCount'),
    },
    service: {
      viewCount: Symbol.for('viewCount.service.viewCount'),
    },
  },
  webhook: {
    repository: {
      config: Symbol.for('webhook.repository.config'),
      delivery: Symbol.for('webhook.repository.delivery'),
    },
  },

  workOrder: {
    repository: {
      workOrder: Symbol.for('workOrder.repository.workOrder'),
      workOrderItem: Symbol.for('workOrder.repository.workOrderItem'),
      workOrderTask: Symbol.for('workOrder.repository.workOrderTask'),
      workOrderRemarksActivity: Symbol.for('workOrder.repository.workOrderRemarksActivity'),
      workOrderAsset: Symbol.for('workOrder.repository.workOrderAsset'),
      workOrderInsufficientItem: Symbol.for('workOrder.repository.workOrderInsufficientItem'),
    },
    service: {
      stateTransition: Symbol.for('workOrder.service.stateTransition'),
      checkAllItemAvailability: Symbol.for('workOrder.service.checkAllItemAvailability'),
      refreshInsufficientItems: Symbol.for('workOrder.service.refreshInsufficientItems'),
      cloneWorkOrder: Symbol.for('workOrder.service.cloneWorkOrder'),
    },
  },

  hauler: {
    repository: {
      milkPickup: Symbol.for('hauler.repository.milkPickup'),
      gradeType: Symbol.for('hauler.repository.gradeType'),
      driver: Symbol.for('hauler.repository.driver'),
      route: Symbol.for('hauler.repository.route'),
      routeDetails: Symbol.for('hauler.repository.routeDetails'),
      customer: Symbol.for('hauler.repository.customer'),
      hauler: Symbol.for('hauler.repository.hauler'),
      milkPickupDetails: Symbol.for('hauler.repository.milkPickupDetails'),
      milkPickupDeliveries: Symbol.for('hauler.repository.milkPickupDeliveries'),
      customerAsset: Symbol.for('hauler.repository.customerAsset'),
      driverAsset: Symbol.for('hauler.repository.driverAsset'),
      milkPickupAsset: Symbol.for('hauler.repository.milkPickupAsset'),
    },
    service: {
      createMilkPickup: Symbol.for('hauler.service.createMilkPickup'),
      updateMilkPickup: Symbol.for('hauler.service.updateMilkPickup'),
      acceptAndSignTicket: Symbol.for('hauler.service.acceptAndSignTicket'),
      syncOfflineTickets: Symbol.for('hauler.service.syncOfflineTickets'),
      saveDriver: Symbol.for('hauler.service.saveDriver'),
      saveRoute: Symbol.for('hauler.service.saveRoute'),
      changeRoutePosition: Symbol.for('hauler.service.changeRoutePosition'),
      getOverviewData: Symbol.for('hauler.service.getOverviewData'),
      forceSyncToPayroll: Symbol.for('hauler.service.forceSyncToPayroll'),
      sendToMilkProducer: Symbol.for('hauler.service.sendToMilkProducer'),
      getNearbyCustomers: Symbol.for('hauler.service.getNearbyCustomers'),
      createCustomerPayrollIntegrated: Symbol.for('hauler.service.createCustomerPayrollIntegrated'),
      registerNewDriver: Symbol.for('hauler.service.registerNewDriver'),
      extractPickupFromAudio: Symbol.for('hauler.service.extractPickupFromAudio'),
      extractPickupsFromManifest: Symbol.for('hauler.service.extractPickupsFromManifest'),
    },
    queue: {
      extraction: Symbol.for('hauler.queue.extraction'),
    },
    gateway: {
      payrollSync: Symbol.for('hauler.gateway.payrollSync'),
      /** @deprecated Use IocKey.totalmilk.gateway.tmms instead */
      featherDb: Symbol.for('totalmilk.gateway.tmms'),
    },
  },

  totalmilk: {
    gateway: {
      tmms: Symbol.for('totalmilk.gateway.tmms'),
    },
  },

  mongodbConnection: Symbol.for('core.mongodbConnection'),
  expressApp: Symbol.for('core.expressApp'),

  //repository -- REMOVE THIS

  timezoneRepository: Symbol.for('core.timezoneRepository'),

  //reports and factory
  pdfReportFactory: Symbol.for('report.factory.pdf'),
  pdfReport: Symbol.for('report.pdf'),
  htmlReportFactory: Symbol.for('report.factory.html'),
  htmlReport: Symbol.for('report.html'),
  csvReportFactory: Symbol.for('report.factory.csv'),
  csvReport: Symbol.for('report.csv'),
  xlsReportFactory: Symbol.for('report.factory.xls'),
  xlsReport: Symbol.for('report.xls'),
  pivotReportFactory: Symbol.for('report.factory.pivot'),
  pivotReport: Symbol.for('report.pivot'),

  //config variable
  config: {
    appConfig: Symbol.for('config.app'),
    blogConfig: Symbol.for('config.blog'),
    cloudinaryConfig: Symbol.for('config.cloudinary'),
    chatConfig: Symbol.for('config.chat'),
    googleConfig: Symbol.for('config.google'),
    jsReportConfig: Symbol.for('config.jsReport'),
    mailgunConfig: Symbol.for('config.mailgun'),
    stripeConfig: Symbol.for('config.stripe'),
    payMongoConfig: Symbol.for('config.payMongo'),
    paymentConfig: Symbol.for('config.payment'),
    ghostConfig: Symbol.for('config.ghost'),
    quickbooksConfig: Symbol.for('config.quickbooks'),
    shipEngineConfig: Symbol.for('config.shipEngine'),
    s3Config: Symbol.for('config.s3'),
    timezoneDbConfig: Symbol.for('config.timezoneDb'),
    vonageConfig: Symbol.for('config.vonage'),
    winstonLoggerConfig: Symbol.for('config.winstonLogger'),
    textBeeConfig: Symbol.for('config.textBee'),
    simConfig: Symbol.for('config.sim'),
    bullConfig: Symbol.for('config.bull'),
    imgProxyConfig: Symbol.for('config.imgProxy'),
    openAiConfig: Symbol.for('config.openAi'),
    aiUsageConfig: Symbol.for('config.aiUsageConfig'),
    passkeyConfig: Symbol.for('config.passkey'),
    mcpConfig: Symbol.for('config.mcp'),
    haulerConfig: Symbol.for('config.hauler'),
    tmmsConfig: Symbol.for('config.tmms'),
    googleAiStudioConfig: Symbol.for('config.googleAiStudio'),
    zaiConfig: Symbol.for('config.zai'),
    moonshotConfig: Symbol.for('config.moonshot'),
  },

  ai: {
    repository: {
      currencyRate: Symbol.for('ai.repository.currencyRate'),
      // Genuinely cross-module — QuickScore's `PreviewSchoolInvite`/`RedeemSchoolInvite`/
      // `SchoolAdminReadService` (pooled-credit pricing) read balances/ledger rows directly, and
      // `SchoolResolver.schoolLedger` reads the ledger directly. `JoinSchool`'s balance MOVE
      // itself goes through `ai.service.transferCredits` instead of these. Bound like
      // `currencyRate` above rather than kept module-internal.
      creditAccount: Symbol.for('ai.repository.creditAccount'),
      aiCreditTransaction: Symbol.for('ai.repository.aiCreditTransaction'),
    },
    service: {
      prompt: Symbol.for('ai.service.prompt'),
      whisper: Symbol.for('ai.service.whisper'),
      generateText: Symbol.for('ai.service.generateText'),
      streamChat: Symbol.for('ai.service.streamChat'),
      analyzeImage: Symbol.for('ai.service.analyzeImage'),
      analyzeImages: Symbol.for('ai.service.analyzeImages'),
      summarizeTranscription: Symbol.for('ai.service.summarizeTranscription'),
      transcribeAudio: Symbol.for('ai.service.transcribeAudio'),
      rateLimiter: Symbol.for('ai.service.rateLimiter'),
      publicMetadataKeyLoader: Symbol.for('ai.service.publicMetadataKeyLoader'),
      recordAndDebitAiUsage: Symbol.for('ai.service.recordAndDebitAiUsage'),
      assertSufficientCredits: Symbol.for('ai.service.assertSufficientCredits'),
      checkVisionModelRate: Symbol.for('ai.service.checkVisionModelRate'),
      settleCreditPurchase: Symbol.for('ai.service.settleCreditPurchase'),
      grantOnboardingCredits: Symbol.for('ai.service.grantOnboardingCredits'),
      // Genuinely cross-module — QuickScore's `CreateSchool` seeds a school's pooled
      // `CreditAccount` at zero via the same atomic `$inc` + upsert primitive
      // `DebitCredits`/`GrantCredits` use internally.
      incrementBalance: Symbol.for('ai.service.incrementBalance'),
      // Genuinely cross-module — QuickScore's `JoinSchool` moves a teacher's whole balance into
      // the school's pool through this, rather than hand-rolling the compare-and-set debit +
      // paired ledger rows itself.
      transferCredits: Symbol.for('ai.service.transferCredits'),
      // Genuinely cross-module — QuickScore's `SchoolAdminReadService.schoolLedgerGetTotals`
      // needs the token/credit/markup aggregate over `AiCreditTransaction` (the usage-detail
      // columns are native to it), which lives with the repository it reads.
      getCreditLedgerTotals: Symbol.for('ai.service.getCreditLedgerTotals'),
    },
    tool: {
      factory: Symbol.for('ai.tool.factory'),
      tool: Symbol.for('ai.tool.tool'),
      functions: {
        //this needs to be string, to be used as key in tool configuration of openai
        runQuery: 'runQuery',
      },
    },
    mcpTool: {
      createProduct: Symbol.for('ai.mcpTool.createProduct'),
    },
    queue: {
      analyzePhoto: Symbol.for('ai.queue.analyzePhoto'),
    },
  },
}
